import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgxAutocomPlaceModule } from 'ngx-autocom-place';
import { NgbModule, NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { NgxFocusTrapModule } from 'ngx-focus-trap';
//Module to have mask over phone number
import { NgxMaskModule, IConfig } from 'ngx-mask';
export const options: Partial<IConfig> | (() => Partial<IConfig>) = null;
import { NgCircleProgressModule } from 'ng-circle-progress';
import { CustomHeaderComponent } from './components/custom-header/custom-header.component';
import { CustomFooterComponent } from './components/custom-footer/custom-footer.component';
import { BaseViewComponent } from './components/base-view/base-view.component';
import { TitleSectionComponent } from './components/title-section/title-section.component';
import { CustomerDetailsComponent } from './components/customer-details/customer-details.component';
import { A11yModule } from '@angular/cdk/a11y';
import { MatTabsModule } from '@angular/material/tabs';

//Exp Mgmt Framework Modules
import { EnvironmentConfig } from '../environments/environmentConfig';
import { FormPreScriptFunctions } from './form-utlity/form-preScript-function';
import { FormPostScriptFunctions } from './form-utlity/form-postScript-function';
import { FormCustomValidatorFunctions } from './form-utlity/form-customValidators';
import { FormElementScriptFunctions } from './form-utlity/form-elementScript-function';
import { CommonUtilityModule, MHttpClient } from '@mmortgage/common-utility';
import { CommonModule, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { DynamicFormModule } from '@mmortgage/dynamic-form';
//import { TestDynamicFormComponent } from './components/test-dynamic-form/test-dynamic-form.component';
import { PersonalInformationComponent } from './components/personal-information/personal-information.component';
import { CoApplicantSelectionComponent } from './components/co-applicant-selection/co-applicant-selection.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { SignOnComponent } from './components/sign-on/sign-on.component';
import { CBConsentComponent } from './components/cb-consent/cb-consent.component';
//import { CIBCCustomerSelectionComponent } from './components/cibc-customer-selection/cibc-customer-selection.component';
import { IncomeComponent } from './components/income/income.component';
import { SummaryComponent } from './components/summary/summary.component';
import { RequestCallbackComponent } from './components/request-callback/request-callback.component';
import { CoApplicantFlowStartComponent } from './components/co-applicant-flow-start/co-applicant-flow-start.component';
import { LandingComponent } from './components/landing/landing.component';
import { UserIdleModule } from 'angular-user-idle';
import { timeHorizonComponent } from './components/time-horizon/time-horizon.component';
import { sessionConstants } from './constants';
import { animate, transition } from '@angular/animations';
import { ErrorHandler } from '@angular/core';
import { ErrorHandlerService } from './model/errorHandler';
import { AppInsightsLoggingService } from './service/appinsights-logging.service';
import { MycurrencyPipe } from './components/directive/mycurrency.pipe';
import { MycurrencyDirective } from './components/directive/mycurrency.directive';
import { MycurrencyDirectiveFr } from './components/directive/mycurrencyfr.directive';
import { MycurrencyFrPipe } from './components/directive/mycurrencyFr.pipe';
import { UtilService } from './service/util.service';
import { personalInformationAboutYourselfComponent } from './components/personal-information-about-yourself/personal-information-about-yourself.component';
import { personalInformationAddressComponent } from './components/personal-information-address/personal-information-address.component';
import { verifyIdentityComponent } from './components/verify-identity/verify-identity.component';
import { personalInformationContactComponent } from './components/personal-information-contact/personal-information-contact.component';
import { personalInformationPreviewComponent } from './components/personal-information-preview/personal-information-preview.component';
import { CancelButtonComponent, DialogContentExampleDialog } from './components/cancel-button/cancel-button.component';
import { CibcCustomerRelationshipComponent } from './components/cibc-customer-relationship/cibc-customer-relationship.component';
import { TrapFocusDirectiveDirective } from './components/directive/trap-focus-directive.directive';
import { ViewAuditDetailsComponent } from './audit/viewAuditDetails/viewAuditDetails.component'
import { AuditHeaderComponent } from './audit/auditHeader/auditHeader.component'
import { IntegrationAuditComponent } from './audit/integrationAudit/integrationAudit.component'
import { AuditRequestComponent } from './audit/auditRequest/auditRequest.component'
import { FACEBOOK_PIXEL_PROVIDER } from './service/paid-pixel.provider'
import { personalInformationContactUpdatedComponent } from './components/personal-information-contact_update/personal-information-contact_update';
import { YourOnlineExclusiveRateOffersComponent } from './components/your-online-exclusive-rate-offers/your-online-exclusive-rate-offers.component';
import { AdditionalMortgageDetailsComponent } from './components/additional-mortgage-details/additional-mortgage-details.component';
import { AddressValidationPopupComponent } from './components/address-validation-popup/address-validation-popup.component';
import { DemoEcifValidation } from './components/demo-ecif/demo-ecif-validation';
import { DemoTransUnion } from './components/demo_TU/demo-trans-union';
import { DemoCifCreation } from './components/demo_CIF_creation/demo-cif-creation';
import { MortgageDetailComponent } from './components/mortgage_details/mortgage_details.component';
import { EstimatedValueOfHomeComponent } from './components/estimated-value-of-home/estimated-value-of-home.component';
import { MortgageProviderComponent } from './components/mortgage_provider/mortgage_provider.component';
import { DemoDmMaturity } from './components/demo-dm-maturity/demo-dm-maturity';
import { DEmoDmResultPanel } from './components/demo-dm-result-panel/demo-dm-result-panel';
import { PreviewComponent } from './components/preview/preview.component';
@NgModule({
  declarations: [
    AppComponent,
    CustomHeaderComponent,
    personalInformationAddressComponent,
    CustomFooterComponent,
    BaseViewComponent,
    TitleSectionComponent,
    CustomerDetailsComponent,
    //TestDynamicFormComponent,
    CoApplicantSelectionComponent,
    PersonalInformationComponent,
    DialogContentExampleDialog,
    //CIBCCustomerSelectionComponent,
    SidebarComponent,
    SignOnComponent,
    CBConsentComponent,
    IncomeComponent,
    verifyIdentityComponent,
    personalInformationAboutYourselfComponent,
    SummaryComponent,
    RequestCallbackComponent,
    CoApplicantFlowStartComponent,
    LandingComponent,
    MycurrencyDirective,
    MycurrencyDirectiveFr,
    MycurrencyPipe,
    MycurrencyFrPipe,
    personalInformationContactComponent,
    personalInformationPreviewComponent,
    CancelButtonComponent,
    TrapFocusDirectiveDirective,
    CibcCustomerRelationshipComponent,
    ViewAuditDetailsComponent,
    AuditHeaderComponent,
    IntegrationAuditComponent,
    AuditRequestComponent,
    //  NewPersonalInformationComponent
    timeHorizonComponent,
    personalInformationContactUpdatedComponent,
    YourOnlineExclusiveRateOffersComponent,
    AdditionalMortgageDetailsComponent,
    AddressValidationPopupComponent,
    DemoEcifValidation,
    DemoTransUnion,
    DemoCifCreation,
    MortgageDetailComponent,
    EstimatedValueOfHomeComponent,
    MortgageProviderComponent,
    DemoDmMaturity,
    DEmoDmResultPanel,
    PreviewComponent
  ],
  entryComponents: [DialogContentExampleDialog],
  imports: [
    BrowserModule,
    MatDialogModule,
    MatDialogModule,
    BrowserAnimationsModule,
    NgxFocusTrapModule,
    AppRoutingModule,
    A11yModule,
    UserIdleModule.forRoot({ idle: sessionConstants.IDEALTIME, timeout: sessionConstants.TIMEOUT }),
    // ngx-translate and the loader module
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    NgxMaskModule.forRoot(),
    NgCircleProgressModule.forRoot(),
    CommonModule,
    NgxAutocomPlaceModule,
    NgbModule,
    CommonUtilityModule.forRoot(EnvironmentConfig),
    DynamicFormModule.forRoot(EnvironmentConfig, FormPreScriptFunctions, FormPostScriptFunctions,
      FormCustomValidatorFunctions, FormElementScriptFunctions),
    NgbModule,
    MatTabsModule,
    NgbPopoverModule
  ],
  providers: [MycurrencyPipe, MycurrencyFrPipe, UtilService, EnvironmentConfig, FACEBOOK_PIXEL_PROVIDER],
  bootstrap: [AppComponent]
})
export class AppModule { }
// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http);
}
transition('open => closed', [
  animate('1s')
])